module.exports = __webpack_public_path__ + "img/coupons_bg_cn.f17af9a3.png";